/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { JobStatus } from '../../models/job-status';

export interface TriggerSrsDataCollection$Params {
  serialnumber: string;
  materialnumber: number;
  modality: string;
  softwareVersion?: string;
}

export function triggerSrsDataCollection(http: HttpClient, rootUrl: string, params: TriggerSrsDataCollection$Params, context?: HttpContext): Observable<StrictHttpResponse<JobStatus>> {
  const rb = new RequestBuilder(rootUrl, triggerSrsDataCollection.PATH, 'post');
  if (params) {
    rb.query('serialnumber', params.serialnumber, {});
    rb.query('materialnumber', params.materialnumber, {});
    rb.query('modality', params.modality, {});
    rb.query('softwareVersion', params.softwareVersion, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<JobStatus>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
triggerSrsDataCollection.PATH = '/api/jobs/srsdatacollection/trigger';
triggerSrsDataCollection.METHOD = 'post';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
triggerSrsDataCollection.ROOTURL = '/portal';
